import { useParams } from "react-router";
import { FC } from "react";
import useLocale from "~/hook/useLocale";
import { isMediaAudioOnly } from "~/utils/helper-funcations";
import { Carousel, CarouselContent, CarouselItem } from "../ui/carousel";
import RectangularCard from "./RectangularCard";
import { DifferentComponentDetailsType, DifferentViewComponentProps } from "./type";
import { DISPLAY_TYPE } from "./video-data";

export const MEDIA_TYPE = "audio_only";
const Rectangular: FC<DifferentViewComponentProps> = ({ data, section_name, url_slug }) => {
  const { video_category } = useParams();
  const { LocalizedLink } = useLocale();

  const RenderVideoItem = (item: DifferentComponentDetailsType) => {
    const navigateTo =
      item.node_type === DISPLAY_TYPE.branch || item.node_type === DISPLAY_TYPE.playlist_list || item.node_type === DISPLAY_TYPE.playlist_series
        ? `/${video_category}/${url_slug}/${item.url_slug}`
        : `/${video_category}/${url_slug}`;
    return (
      <LocalizedLink
        className="rounded-lg w-full hover:bg-secondaryColor z-10"
        to={navigateTo}
        query={!item.node_type ? { watch: item.id, media: item?.media_type ? isMediaAudioOnly(item?.media_type) : undefined } : undefined}
      >
        <RectangularCard
          data={{
            video_id: item.videoID.length === 0 || item.videoID === null ? null : item.videoID,
            name: item.name,
            record_date: item.record_date,
            duration_sec: item.duration_sec,
            img: item.img ?? null,
            node_type: item?.node_type || null,
            part: item.total_playlist_item,
            vertical_img: item.vertical_img ?? null,
            square_img: item.square_img ?? null,
            media_type: item.media_type ?? null,
            playlist_item_count: item.count ?? null,
          }}
        />
      </LocalizedLink>
    );
  };

  return data.length ? (
    <>
      {/* Mobile Carousel - visible only on mobile screens */}
      <div className="block md:hidden">
        <Carousel
          opts={{
            align: "start",
            loop: false,
            dragFree: true,
            containScroll: "trimSnaps",
          }}
          className="w-full"
        >
          <CarouselContent className="p-3">
            {data.map((item) => (
              <CarouselItem key={item.id} className="basis-[47%]">
                <RenderVideoItem {...item} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>

      {/* Desktop Grid - visible only on desktop screens */}
      <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-5 gap-4">
        {data.map((item) => (
          <div key={item.id}>
            <RenderVideoItem {...item} />
          </div>
        ))}
      </div>
    </>
  ) : (
    <div className="text-center text-textSecondaryColor font-inter text-14">No {section_name ? section_name : "videos"} found in this section.</div>
  );
};

export default Rectangular;
